import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // fetched data remains "fresh" for 5 minutes
      staleTime: 1000 * 60 * 5,
    },
  },
});
